module.exports = __webpack_public_path__ + "static/media/nano.9a3a6c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/nano.png
// module id = 18
// module chunks = 0